import React from 'react';
import { Button } from '@/components/ui/button';
import { ShoppingCart, Banknote, CreditCard } from 'lucide-react';

/**
 * MobileBottomBar - Fixed bottom bar for mobile/tablet POS
 * Always visible, shows cart summary and payment buttons
 */
export default function MobileBottomBar({ 
  cart, 
  cartTotal, 
  onOpenCart, 
  onPayCash, 
  onPayCard,
  formatCurrency 
}) {
  const itemCount = cart.reduce((sum, item) => sum + item.quantity, 0);
  
  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-[#0B1220]/95 backdrop-blur-xl border-t border-slate-700/60 safe-area-bottom"
      data-testid="mobile-bottom-bar"
    >
      <div className="flex items-center justify-between h-20 px-3 gap-2">
        {/* Cart Button - Opens Drawer */}
        <Button
          onClick={onOpenCart}
          variant="outline"
          className="flex-1 h-14 border-slate-600/60 bg-slate-800/50 hover:bg-slate-700/50 flex items-center justify-center gap-3"
          data-testid="mobile-cart-button"
        >
          <div className="relative">
            <ShoppingCart size={22} className="text-teal-400" />
            {itemCount > 0 && (
              <span className="absolute -top-2 -right-2 w-5 h-5 bg-teal-500 text-white text-xs font-bold rounded-full flex items-center justify-center">
                {itemCount}
              </span>
            )}
          </div>
          <div className="text-left">
            <div className="text-xs text-slate-400">Warenkorb</div>
            <div className="text-lg font-bold text-teal-400">
              {formatCurrency ? formatCurrency(cartTotal) : `${cartTotal.toFixed(2)}€`}
            </div>
          </div>
        </Button>
        
        {/* Payment Buttons */}
        <div className="flex gap-2">
          <Button
            onClick={onPayCash}
            disabled={cart.length === 0}
            className="h-14 w-24 bg-gradient-to-r from-emerald-600 to-emerald-500 hover:from-emerald-500 hover:to-emerald-400 text-white font-bold shadow-lg shadow-emerald-500/20 disabled:opacity-50 disabled:cursor-not-allowed flex flex-col items-center justify-center gap-0.5"
            data-testid="mobile-pay-cash"
          >
            <Banknote size={20} />
            <span className="text-xs">Bar</span>
          </Button>
          <Button
            onClick={onPayCard}
            disabled={cart.length === 0}
            className="h-14 w-24 bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white font-bold shadow-lg shadow-blue-500/20 disabled:opacity-50 disabled:cursor-not-allowed flex flex-col items-center justify-center gap-0.5"
            data-testid="mobile-pay-card"
          >
            <CreditCard size={20} />
            <span className="text-xs">Karte</span>
          </Button>
        </div>
      </div>
    </div>
  );
}
